<template>
  <div class="pokerwizard-dashboard">
    <iframe
      ref="dashboardIframe"
      :src="dashboardUrl"
      frameborder="0"
      name="pokerwizard-dashboard"
    ></iframe>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

const store = useStore()
const gtoRefresh = computed(() => store.getters.user_info.refresh)

const route = useRoute()
const utmSource = route.query.utm_source || 'manual'

const dashboardUrl = `${import.meta.env.VITE_POKER_WIZARD_URL as string}?iframe=true&utm_source=${utmSource}&origin=${window.location.origin}`
const dashboardIframe = ref<HTMLIFrameElement | null>(null)
let authToken: string | null = null

const handleMessage = (event: MessageEvent) => {
  const isFromDashboard = event.source === dashboardIframe.value?.contentWindow

  // message from dashboard running in iframe
  if (isFromDashboard && event.data && event.data.type === 'open_tab_for_url') {
    const url = new URL(event.data.url)

    if (event.data.authToken) {
      authToken = event.data.authToken
      url.searchParams.set('origin', window.location.origin)
    }

    window.open(url, '_blank')
    return
  }

  // message from dashboard running in iframe requesting GTO wizard jwt token
  if (isFromDashboard && event.data === 'request_gto_token') {
    ;(event.source as Window).postMessage(
      { type: 'gto_token', gtoToken: gtoRefresh.value },
      event.origin,
    )

    return
  }

  // message from opened game tab
  const isFromNewTab = new URL(dashboardUrl).origin === event.origin
  if (isFromNewTab && event.data === 'request_auth_token') {
    ;(event.source as Window).postMessage({ type: 'auth_token', authToken }, event.origin)
  }
}

onMounted(() => {
  window.addEventListener('message', handleMessage)
})

onUnmounted(() => {
  window.removeEventListener('message', handleMessage)
})
</script>

<style lang="scss" scoped>
.pokerwizard-dashboard {
  width: 100%;
  height: 100%;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
